/**
 * Carrega o dataset do dashboard uma única vez por tela e distingue
 * carregando / erro / dado (Task 10). Páginas não repetem essa lógica.
 */
import { createElement as h, type ReactElement } from "react";
import { StatusPanel, errorDetail } from "./StatusPanel.js";
import { useDashboardDataset } from "../queries.js";
import type { DashboardDataset } from "../dashboard/kpis.js";

export interface DatasetBoundaryProps {
  children: (dataset: DashboardDataset) => ReactElement;
}

export function DatasetBoundary({ children }: DatasetBoundaryProps): ReactElement {
  const query = useDashboardDataset();
  if (query.isPending) {
    return h(StatusPanel, { kind: "loading", title: "Carregando dados da operação…" });
  }
  if (query.error) {
    return h(StatusPanel, {
      kind: "error",
      title: "Não foi possível carregar os dados da operação",
      detail: errorDetail(query.error)
    });
  }
  if (!query.data) {
    return h(StatusPanel, { kind: "empty", title: "Nenhum dado retornado pela API da Plataforma" });
  }
  return children(query.data);
}
